// extracted by mini-css-extract-plugin
export default {"mySwiper":"gallery_mySwiper__23fED","swiperslide":"gallery_swiperslide__F0E84","img":"gallery_img__1TT0g"};